export const getTranslationForSequenceType = (type) => ({
  VIDEO: 'video',
  AUDIO: 'audio',
  PICTURE: 'picture'
})[type]

export const ORIENTATION = {
  vertical: 'VERTICAL',
  horizontal: 'HORIZONTAL'
}

export const SEQUENCE_STATUS = {
  PENDING: 'PENDING',
  DOING: 'DOING',
  PENDING_VALIDATION: 'PENDING_VALIDATION',
  PENDING_SUBMISSION: 'PENDING_SUBMISSION',
  PENDING_UPLOAD: 'PENDING_UPLOAD',
  PUSHED: 'PUSHED',
  FAILED: 'FAILED',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED'
}